<template>
  <DSButton
    :class="[DS_DRAG_HANDLE_CLASSES.DragHandle, `${DS_DRAG_HANDLE_CLASSES.DragHandle}--${props.size}`]"
    :aria-label="props.ariaLabel"
    :disabled="props.disabled"
    :variant="props.variant"
    :size="props.size"
    type="button"
    prefix-icon="dragger"
    data-cy="ds-drag-handle"
  />
</template>

<script setup lang="ts">
import DSButton from "../../button/components/DSButton.vue";
import { DS_BUTTON_SIZE } from "@/src/design_system/button_and_controls/button/types/props";
import { DS_DRAG_HANDLE_CLASSES } from "@/src/design_system/button_and_controls/drag_handle/constants/classes";
import {
  DS_DRAG_HANDLE_VARIANT,
  type DSDragHandleProps,
} from "@/src/design_system/button_and_controls/drag_handle/types/props";

const props = withDefaults(defineProps<DSDragHandleProps>(), {
  ariaLabel: "Drag to reorder",
  disabled: false,
  size: DS_BUTTON_SIZE.Small,
  variant: DS_DRAG_HANDLE_VARIANT.Secondary,
});
</script>
